<!-- 召回订单 -->
<template>
    <el-dialog :title="msg('召回订单')" :visible.sync="visible" :fullscreen="isMinScreen" 
        :close-on-click-modal="false" 
        width="400px"
    >
        <el-row>
            <!-- <el-col :gutter="10" :xs="24" :sm="8" style="margin-top:10px;">
                <label class="el-form-item__label">单号：</label>
            </el-col> -->
            <el-col :gutter="10" :xs="24" :sm="16" style="margin-top:0px;">
                <span>输入单号：每次最多10个订单</span>
                <el-input type="textarea" :rows="5" v-model="codes">
                </el-input>
            </el-col>
            <el-col style="margin-top:15px; text-align:left;" :xs="24">
                <el-button  type="primary" size="mini" @click="doUpdate">确定</el-button>
                <el-button type="danger" size="mini" @click="visible = false" style="margin-right:25px;">取消</el-button>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
export default {
    name: "ShopOrderUpdateDialog",
    data(){
        return {
            visible: false,
            shopId:null,
            owner:null,
            codes:null,
            preCodes:null,
        }
    },
    computed: {
        isMinScreen: { //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        },
    },
    methods: {
        showDialog(shopId,owner){
            this.codes = null;
            this.preCodes = null;
            this.shopId = shopId;
            this.visible = true;
            this.owner = owner;
        },
        doUpdate(){

            if(!this.shopId){
                this.$message(this.msg('请选择店铺'));
                return;
            }
            if(!this.codes){
                this.$message(this.msg('请选择输入单号'));
                return;
            }
            if(this.codes){
                this.preCodes = this.codes;
                let cs = this.codes.split(/\s+/);

                let css = [];
                for(let i=0; i<cs.length; i++){
                    if(cs[i]) css.push(cs[i]);
                }
                this.codes = css.join(",");
            }else{
                this.codes = '';
            }
            this.$axios.post(this.$kit.api.shop.shopOrderUpdateOwner
                +"?shopId="+this.shopId+"&owner="+this.owner,this.codes
            ).then((result) => {
                this.$message(result.msg);
                this.codes = this.preCodes;
                if (result.status) {
                    this.visible = false;
                    this.codes = null;
                }
            });
        }
    }

}
</script>